import { render, staticRenderFns } from "./TextsPreview.vue?vue&type=template&id=2a061c1a&lang=pug&"
import script from "./TextsPreview.vue?vue&type=script&lang=js&"
export * from "./TextsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports